import { render, staticRenderFns } from "./NarrativeCover.vue?vue&type=template&id=f95a5676&scoped=true&"
import script from "./NarrativeCover.vue?vue&type=script&lang=js&"
export * from "./NarrativeCover.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeCover.vue?vue&type=style&index=0&id=f95a5676&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95a5676",
  null
  
)

export default component.exports